import React from 'react'
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import { data } from '../testimonialSource';
//Owl Carousel Settings
const options = {
    margin: 30,
    responsiveClass: true,
    nav: false,
    dots:true,
    loop:true,
    autoplay: true,
    smartSpeed: 500,
    responsive: {
        0: {
            items: 1,
        },
        400: {
            items: 1,
        },
        600: {
            items: 1,
        },
        700: {
            items: 1,
        },
        1000: {
            items: 1,
        }
    },
};

function Testimonial() {
    
  return (
   <>
       {/* <!--testimonial section start--> */}
            <section className="testimonial-section ptb-100" style={{background:"linear-gradient(180deg,#00A0E3 10%, #3E3687)" }}>
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-md-6 col-lg-5">
                            <div className="testimonial-heading text-white">
                                <h2 className="text-white">What Our Client Say About Us</h2>
                                <span className="animate-border mb-4"></span>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-6">
                            <div className="testimonial-content-wrap">
                                <img src="assets1/img/testimonial-arrow-top.png" className="img-fluid testimonial-tb-shape shape-top"
                                     alt="testimonial shape" />
                                <OwlCarousel className="owl-carousel owl-theme client-testimonial-1 custom-dot testimonial-shape" {...options}>
                                {
                                    data.map((item,id) => (
                                    <div className="item" key={id}>
                                        <div className="testimonial-quote-wrap">
                                            <div className="media author-info mb-3">
                                                <div className="author-img mr-3">
                                                    <img src={item.img} alt="client" className="img-fluid" />
                                                </div>
                                                <div className="media-body text-white">
                                                    <h5 className="mb-0 text-white">{item.name}</h5>
                                                    <span>{item.designation}</span>
                                                </div>
                                                <span className="fas fa-quote-right icon-md text-white"></span>
                                            </div>
                                            <div className="client-say text-white">
                                                <p>{item.content}</p>
                                            </div>
                                        </div>
                                    </div>
                                    ))
                                }
                                </OwlCarousel>
                                <img src="assets1/img/testimonial-arrow-bottom.png" className="img-fluid testimonial-tb-shape shape-bottom"
                                     alt="testimonial shape" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <!--testimonial section end--> */}
   </>
  )
}

export default Testimonial
